import { db } from './firebase';
import moment from 'moment'
// User API
import { doDeleteApplication } from './database/handleApplications'

export const doCreateUser = (uid, username, email, role) =>
  db.ref(`users/${uid}`).set({
    name: username,
    email:  email,
    id: uid,
    role: role
  });

export const doLogUser = (id) => {
  const timeStamp = moment().format()
  return db.ref('userOnline').child(id).set({
    userId: id,
    loggedIn: timeStamp
  })
}

export const doUnlogUser = (id) => {
  return db.ref('userOnline').child(id).once('value', (snapshot)=> {
    if(snapshot.exists()) {
      return db.ref('userOnline').child(id).remove()
    }
  })
   
}


export const fetchUserProfile = (id) =>  {
  const profile = []
  
  
  return db.ref('users').child(id).once('value', snapshot => profile.push(snapshot.val()))
  .then(()=>profile[0])
}

export const fetchTasks = db.ref('tasks/')

export const onceGetUsers = () =>
  db.ref('users').once('value');

export const doAddEvent = (timeRange, date, task, ort, info, uid, pkwChecked, author, time, taskId) => {

  // set Timestamp for Event creation date
  const timeStamp = moment().format()

  var newEventId = db.ref().child('events').push().key
  const updates = {}
  const newEvent = {
    state: {
      currentState: 'request',
      author: author,
      lastEdit: {
        name: author,
        timeStamp: timeStamp
      }
    },
    data: {
      id: newEventId,
      extId: false,
      created: timeStamp,
      timeRange: timeRange,
      date:  date,
      task: task,
      taskId: taskId,
      ort: ort,
      info: info!=='' ? info : 'Keine vorhanden',
      time: time,
      userId: uid,
      pkw: pkwChecked ? true : false,   
    }
  }
  const myEvents = {
    eventId: newEventId
  }
  
  if(author==='admin') {
    updates['myEvents/admins/' + uid + '/' + newEventId + '/'] = myEvents
  } else {
    updates['myEvents/' + uid + '/' + newEventId + '/'] = myEvents
  }
  updates['events/' + newEventId + '/'] = newEvent

   db.ref('/').update(updates)

  }

  export const doDeleteEvent = async (eventId) => {
    const canidatesRef = db.ref('/canidates')
    const canidatesSnap = await canidatesRef.child(eventId).once('value')
    if(canidatesSnap.exists()) {
      canidatesSnap.forEach(canidate=> {
        doDeleteApplication(eventId, canidate.key)
        //myApplicationsRef.child(canidate.key).child(eventId).remove()
        //canidatesRef.child(eventId).child(canidate.key).remove()
      })
    }
    db.ref('/events').child(eventId).remove()
    
  }

  export const doDelApplication = (eventIndex, userId) => {
  
   db.ref('myApplications/'+userId+'/'+eventIndex).remove()
  }

  export const fetchEvents = db.ref('events/')

  export const myApplicationsRef = (userId) => {
    return db.ref(`myApplications/${userId}`)
  }


  export const bindCanidateToEvent = (events, userId) => {
    db.ref(`myApplications/`).update({
    [userId]: events,
    
    });
  }




// WEBPACK FOOTER //
// ./src/firebase/db.js